import { useEffect } from "react"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { PETestQuestionAnswer } from "src/modules/pe-tests-module/data/interfaces"
import { useTestsStore } from "src/modules/pe-tests-module/data/store"
import Answer from "../Answer"
import { IQuestProps } from "../Question"

let timeout : any = -1
const MultiChoice = ({ item, question, isLocked, isRight, choosedId, setIsRight, setChoosedId, setIsLocked }: IQuestProps ) : JSX.Element => {
     
    useEffect(() => { 
        return () => clearTimeout( timeout )
    }, [])

    const onChoose = ( answer: PETestQuestionAnswer ) => { 
        // console.table({answerId: answer.id})
        if(item.is_show_answer) { 
            setIsRight(question.right_answer_id)
        }  
        useTestsStore.setState({ currentStepValue: answer.id })
        setChoosedId( answer.id )  
        setIsLocked( item.is_show_answer )
        const results = [...useTestsStore.getState().results]
        results[ useTestsStore.getState().currentStep - 1 ] = answer.id
        useTestsStore.setState({ results })
        if(item.is_timed) {
            timeout = setTimeout(() => {
                const next = useTestsStore.getState().currentStep + 1
                useTestsStore.setState({ 
                    currentStep: next
                })
            }, 800)
            
        } 
    }
    const _answers = question.answers?.map((answer: PETestQuestionAnswer) => {
        return <Answer
            key={answer.id} 
            isRight={isRight === answer.id}
            item={answer}
            isSelect={ answer.id === choosedId }
            onChange={onChoose}
        />
    }) 
    console.log( question )
    return question.id 
        ?
        <div className="pe-matching-single flex-centered flex-column  flex-grow-100 h-100" data-testid="test-question-multi-choice">
            <div className="pe-matching-content short-container" > 
                <div className="pe-matching-media">
                    <img src={question.thumbnail} className="pe-matching-image" alt="" />
                </div>
                <div className="pe-matching-title" data-testid="test-question-title">
                    {question.title} 
                </div>
                <div className="pe-matching-descr" data-testid="test-question-content">
                    {question.post_content}
                </div>
                <div 
                    className={`pe-matching-answers
                        ${!!question.answers?.filter(a => a.thumbnail).length 
                            ? 
                            "flex-row" 
                            : 
                            "flex-column"
                        }
                        ${ isLocked ? " untouchble opacity_75" : "" }
                    `}
                >
                    {_answers}
                </div>
            </div>
        </div>
        :
        <CalloutNoExists /> 
} 
export default MultiChoice